export default {
  allMsg: 'Alle Nachrichten',
  systemMsg: 'Systemnachrichten',
  personMsg: 'Manuelle Nachrichten',
  unread: 'Ungelesen',
  seeDetail: 'Details anzeigen',
  read: 'Gelesen',
  replyNow: 'jetzt antworten',
  message: 'Nachricht',
  operateSuccess: 'Erfolgreich ausgeführt',
  holder: {
    searchHolder: 'Paketnummer/Bestellnummer/Artikelnummer',
  },
  addAcBuy: 'Treten Sie AcBuy Discord bei & gewinnen Sie 2000 ¥ CASH!',
  flatActivity: '🎄 Weihnachtsangebote, Die Man Haben Muss',
  joinNow1: 'Jetzt Einkaufen',
  tips1: '🎁 Bis Zu 80% Rabatt',
  tips2: '🎅 Feiertagsangebote Nur Für Kurze Zeit!',
}
